// Утилита оставлена для возможности переключения на локаль в зависимости от используемого языка и страны
// т.е. в итоговом виде он может принять вид селектора
// createSelector(getLang, getCountryCode, (lang, countryCode) => `${lang}-${countryCode}`);
const LOCALES = new Map([
  ['ru', 'ru-RU'],
  ['kk', 'kk-KZ'],
]);

const LANG_BY_CURRENCY = new Map([
  ['RUB', 'ru'],
  ['KZT', 'kk'],
]);

const CURRENCY_BY_LANG = new Map([
  ['ru', 'RUB'],
  ['kk', 'KZT'],
]);

const CURRENCY_SYMBOL_BY_CURRENCY = new Map([
  ['RUB', '₽'],
  ['KZT', '₸'],
]);

export const getLocale = (lang = 'ru') => LOCALES.get(lang) as string;

export const getLangByCurrency = (currency = 'RUB') => LANG_BY_CURRENCY.get(currency) as string;

export const getCurrencyByLang = (lang = 'ru') => CURRENCY_BY_LANG.get(lang) as string;

export const getCurrencySymbolByCurrency = (currency = 'RUB') =>
  CURRENCY_SYMBOL_BY_CURRENCY.get(currency) as string;
